import KeepAlive from 'react-activation'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import RouterLayout from './layout'
import ErrorBoundary from '@/components/ErrorBoundary'
import Discover from '@/pages/Discover'

const DiscoverRedirect = () => {
  const channelSearch = sessionStorage.getItem('channelSearch') || ''
  return <Navigate to={`/home/discover${channelSearch}`} replace />
}

const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    path: '/',
    element: <RouterLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <DiscoverRedirect />,
      },
      {
        path: 'home/discover',
        element: <Discover />,
      },
      {
        path: 'bookList/:id?',
        async lazy() {
          const { default: BookList } = await import('@/pages/BookList')
          return {
            Component: () => (
              <KeepAlive id='bookList' name='bookList'>
                <BookList />
              </KeepAlive>
            ),
          }
        },
      },
      {
        path: 'threadList/:id?',
        async lazy() {
          const { default: ThreadList } = await import('@/pages/ThreadList')
          return {
            Component: () => (
              <KeepAlive id='threadList' name='threadList'>
                <ThreadList />
              </KeepAlive>
            ),
          }
        },
      },
      {
        path: 'detail/content/:type/:id',
        async lazy() {
          const { default: BookDetail } = await import('@/pages/Detail/BookListDetail')
          return { Component: BookDetail }
        },
      },
      {
        path: 'detail/review/:id',
        async lazy() {
          const { default: BookReview } = await import('@/pages/Detail/BookReviewDetail')
          return {
            Component: BookReview,
          }
        },
      },
      {
        path: 'publish',
        async lazy() {
          const { default: CreateStoryList } = await import('@/pages/Publish')
          return { Component: CreateStoryList }
        },
      },
      {
        path: 'notFound',
        async lazy() {
          const { default: NotFound } = await import('@/components/NotFound')
          return { Component: NotFound }
        },
      },
      {
        path: 'share-callback',
        async lazy() {
          const { default: ShareCallback } = await import('@/pages/ShareCallback')
          return { Component: ShareCallback }
        },
      },
    ],
  },
])

export default router
